const experiences = [
    {
        id: 'DH',
        company: 'Digital House',
        link: 'https://www.digitalhouse.com/',
        period: 'Apr 2022 - Apr 2023',
        title: 'Programming Professor - Mercado Libre Bootcamp',
        description: [
            'Technical training of JR and SSR personnel in React, Node, Git, Jest & customer proprietary technologies.',
            'Assistance in technical training of JR and SSR personnel in Java, Spring, SQL, & JPA.',
            'Class teaching, syllabus enhancement & general group coordination.',
            'SCRUM ceremony facilitator within the Bootcamp.',
            'Pair programming & live problem solving.',
            'Production of monthly reports on general and individual client\'s personnel status.'
        ]
    },
    {
        id: 'Henry',
        company: 'Henry',
        link: 'https://www.soyhenry.com/',
        period: 'Oct 2021 - Dec 2021',
        title: 'Full-Stack Teaching Assistant',
        description: [
            'Coordinate a group of 30 students to achieve their integration to the bootcamp\'s study program.',
            'Technical assistance for excercise solving, studying strategy and promotion of pair programming.',
            'Propose ideas to improve the bootcamp\'s processes.'
        ]
    }
]

export default experiences;